module.exports = __webpack_public_path__ + "img/siyi-chen-im-feline-fine.e45f709.jpg";